(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyDisclaimers", function () {
    var controller = [
      "$scope",
      "DisclaimersService",
      function ($scope, DisclaimersService) {
        $scope.disclaimers = [];

        $scope.$watch("tyDisclaimersController.disclaimersList", function (disclaimersArray) {
          DisclaimersService.ingestDisclaimersArray(disclaimersArray);
          var disclaimerKeys = DisclaimersService.ensureSchema(disclaimersArray, "sitecore").map(function (el) {
            return el.title;
          });
          DisclaimersService.addToGroup("all", disclaimerKeys);
        });

        $scope.$watch("tyDisclaimersController.disclaimersInitiallyVisible", function (disclaimersInitiallyVisible) {
          DisclaimersService.showGroup(disclaimersInitiallyVisible);
        });

        $scope.$on("disclaimers-updated", function (event, visibleDisclaimers) {
          $scope.disclaimers = visibleDisclaimers; // this assumes ng-repeat will iterate an object's keys, which we don't know yet
          $scope.$applyAsync();
        });
      },
    ];

    var link = function ($scope, $element, $attrs, $ctrl, $transclude) {
      $transclude($scope, function (clone) {
        $element.append(clone);
      });
    };

    return {
      bindToController: {
        disclaimersList: "<",
        disclaimersInitiallyVisible: "@",
      },
      restrict: "A",
      controller: controller,
      controllerAs: "tyDisclaimersController",
      scope: false,
      link: link,
      transclude: true,
    };
  });
})(window.angular);
